<script setup lang="ts">
import SvgIcon from "@/components/ui/SvgIcon/SvgIcon.vue";

defineProps<{ expanded: boolean }>();
</script>

<template>
  <SvgIcon
    name="arrow/chevron-down"
    width="20"
    height="20"
    class="arrow-icon"
    :class="{ expanded }"
  />
</template>

<style lang="scss" scoped>
.arrow-icon {
  transform: rotate(-90deg);
  transition: transform 0.3s ease;

  &.expanded {
    transform: none;
  }
}
</style>
